export const skipLine = {
  "skip-line": {
    shape:
      '<path fill="#000" fill-opacity=".51" d="M9.5 18.5v-1h2c-.05-2.483-.942-4.6-2.675-6.35C7.092 9.4 4.983 8.525 2.5 8.525v-1c2.267 0 4.263.675 5.988 2.025 1.725 1.35 2.904 3.058 3.537 5.125a10.502 10.502 0 0 1 2.688-4.225 16.353 16.353 0 0 1 4.137-2.925H14.5v-1h6v5.7h-1v-3.9c-1.817.867-3.425 2.079-4.825 3.637-1.4 1.559-2.125 3.405-2.175 5.538h2v1h-5Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
